import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PlatformEnum } from '@panamax/app-state';
import { ProductDetailViewModel } from '@product-detail/models/product-detail-view-model';
import { PdpLnkSrc } from '@shared/constants/pdp-lnksrc.enum';
import { QuantityUpdate } from '@shared/models/quantity-update';

@Component({
  selector: 'app-recommendation-carousel',
  templateUrl: './recommendation-carousel.component.html',
  styleUrls: ['./recommendation-carousel.component.scss'],
})
export class RecommendationCarouselComponent {
  @Input() platformType: PlatformEnum;
  @Input() title: string;
  @Input() isGuestUser: boolean;
  @Input() products: ProductDetailViewModel[];
  @Input() linkSource: PdpLnkSrc;
  @Input() merchFeature = '';
  @Input() addMethod = '';
  @Input() isTopSellersLoading: boolean;

  @Output() quantityUpdateEmitter: EventEmitter<{
    quantityUpdate: QuantityUpdate;
    index: number;
    product: ProductDetailViewModel;
  }> = new EventEmitter();
  @Output() productImpressionsEmitter: EventEmitter<string[]> =
    new EventEmitter();
  @Output() productClickEmitter: EventEmitter<ProductDetailViewModel> =
    new EventEmitter();

  readonly PlatformEnum = PlatformEnum;

  trackByIndex = (index: number, id: any) => index;

  onQuantityUpdate(
    event: QuantityUpdate,
    index: number,
    product: ProductDetailViewModel,
  ) {
    this.quantityUpdateEmitter.emit({ quantityUpdate: event, index, product });
  }

  onProductClick(product: ProductDetailViewModel) {
    this.productClickEmitter.emit(product);
  }
}
